import cornerstone from 'cornerstone-core';

const RECIP_GUIDELINE_ID = 'RECIP10';

export function isRecipGuideline(guideline) {
  return guideline?.id === RECIP_GUIDELINE_ID;
}

function displaySetModality(ds) {
  return ds?.Modality || ds?.modality || null;
}

export function isCtDisplaySet(displaySet) {
  return displaySetModality(displaySet) === 'CT';
}

export function shouldEnableSuv(displaySet) {
  return !!displaySet?.isFusion && isCtDisplaySet(displaySet);
}

export function shouldEnablePsmaVol(guideline) {
  return isRecipGuideline(guideline);
}

function readFrameOfReferenceUID(imageId) {
  return (
    cornerstone.metaData.get('FrameOfReferenceUID', imageId) ||
    cornerstone.metaData.get('imagePlaneModule', imageId)
      ?.frameOfReferenceUID ||
    cornerstone.metaData.get('instance', imageId)?.FrameOfReferenceUID ||
    null
  );
}

/**
 * Runtime FoR guard. PET-first sampling assumes PET and CT are in the same
 * patient coordinate system (no registration). Verify it before sampling.
 * @returns {{ ok: boolean, ctFoR: string|null, petFoR: string|null }}
 */
export function assertSameFrameOfReference(ctImageId, petImageId) {
  const ctFoR = readFrameOfReferenceUID(ctImageId);
  const petFoR = readFrameOfReferenceUID(petImageId);
  const ok = (!!ctFoR && ctFoR === petFoR);
  return { ok, ctFoR, petFoR };
}

